import AboutVision from "./AboutVision";

const MissionVision = () => {
  const focusAreas = [
    {
      src: "/business-idea.svg",
      alt: "business-idea-icon",
      title: "Support Entrepreneurs",
      description: "Deliver unmatched mentorship, training, and guidance.",
    },
    {
      src: "/shuttle.svg",
      alt: "shuttle-icon",
      title: "Simplify Startups",
      description: "Provide actionable frameworks, tools, and resources.",
    },
    {
      src: "/community.svg",
      alt: "community-icon",
      title: "Build Community",
      description: "Foster a global network of thriving founders.",
    },
  ];
  return (
    <div>
      <div>
        <div className="vision-and-mission-container">
          <div>
            <div className="vision-title">Our Vision</div>
            <div className="vision-desc">
              Turn out ideas into loved, thriving businesses.
            </div>
          </div>
          <div>
            <div className="vision-title">Our Mission</div>
            <div className="vision-desc">
              Empower 500 startups in 2025 to launch, grow, and avoid the valley
              of death through expert guidance and strategic support.
            </div>
          </div>
        </div>
        <div className="vision-stage-outercontainer">
          {focusAreas.map((item, index) => (
            <AboutVision data={item} key={index} />
          ))}
          {/* EXAMPLE UNCOMMENT IT TO SEE IN ACTION */}
          {/* <div className="vision-stage-container">
            <div className="vision-stage-logo">
              <img src="community.svg" alt="community-icon" />
            </div>
            <div className="vision-stage-title">Build Community</div>
            <div className="vision-stage-desc">
              Foster a global network of thriving founders.
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default MissionVision;
